import { memo, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import { AppMarkdownParser } from "../../../../shared/components/AppMarkdownParser";

interface Props {
  userMessage: string;
  isLoading?: boolean;
}
const UserMessageInner = ({ userMessage, isLoading }: Props) => {
  const messageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollToBottom();
  }, [userMessage]);

  const scrollToBottom = () => {
    messageRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div ref={messageRef} className={styles["user-message"]}>
      <AppMarkdownParser content={userMessage} />
    </div>
  );
};

export const UserMessage = memo(UserMessageInner);
